import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthGuard } from './auth.guard';
import { RoleGuard } from './role.guard';
import { CanDeactivateContractGuard } from './can-deactivate.guard';
import { AuthGuardAdminService } from './auth-guard-admin-service';

@NgModule({
  providers: [AuthGuard, RoleGuard, CanDeactivateContractGuard, AuthGuardAdminService],
  imports: [CommonModule],
})
export class GuardsModule {}
